import $ from 'jquery';

function ScrollCtrl() {
	this.$win    = $(window);
	this.$body   = $('body');
	this.$target = $('#headerWrap');
	this.$visual = $('#homeVisual');

	this.headerHeight    = this.$target.height();
	this.headerStart     = 100;
	this.headerPos       = 0;
	this.headerOffsetTop = 0;
	this.classScrolled   = 'scrolled';
	this.classScrolldown = 'scrolldown';
	this.visualBottom = this.$visual.height();

	this.scroll     = this.scroll.bind(this);
	this.scrollDown = this.scrollDown.bind(this);
	this.console    = this.console.bind(this);

	this.init();
}

ScrollCtrl.prototype.init = function() {
	this.$win.on('load.headerScrolled', this.scroll);
	this.$win.on('scroll.headerScrolled', this.scroll);
	this.$win.on('scroll.headerScrollDown', this.scrollDown);
}

ScrollCtrl.prototype.scroll = function() {
	let posTop = this.$win.scrollTop();
	if ((this.headerHeight + 250) < posTop) {
		this.$target.addClass(this.classScrolled);
	} else {
		this.$target.removeClass(this.classScrolled);
	}
}

ScrollCtrl.prototype.scrollDown = function() {
	// if (this.$body.hasClass('navi-toggled')) {
	// 	this.$win.off('scroll.headerScrollDown');
	// 	this.$win.off('scroll.headerScrolled');
	// 	return;
	// }
	let posTop = this.$win.scrollTop();
	if (posTop > this.headerPos) {
		if (this.$win.scrollTop() > this.headerHeight) {
			this.$target.addClass(this.classScrolldown);
		}
	} else {
		this.$target.removeClass(this.classScrolldown);
	}

	this.headerPos = posTop;
}

ScrollCtrl.prototype.console = function () {
	const self = this;

	if (typeof $('.js-console').get(0) === 'undefined') {
		let jsConsole = $('<div/>', {
			'class': 'js-console',
			html: function () {
				$('<div/>', {
					'class': 'js-console-in',
				}).appendTo(this);
			},
		}).appendTo(this.$body);
	}

	[].forEach.call(arguments, function (log) {
		let val = '';
		console.log('NaviCtrlConsole: ' + "\n", log);
		switch (log) {
			case true:
				val = 'true';
				break;
			case false:
				val = 'false';
				break;
			case 'undefined':
				val = 'undefined';
				break;
			default:
				val = log;
				break;
		}
		$('.js-console-in').prepend(`<p>${val}</p>`);
	})
}

export default ScrollCtrl;
